import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor(private cookieService: CookieService) { }

  // Function to clear all cookies
  clearAllCookies() {
    const cookieValue = this.cookieService.get("token");
   // console.log(cookieValue);
    if (cookieValue === undefined || cookieValue === '') {

      this.cookieService.delete('token','/');
      this.cookieService.delete('refresh_token','/');
      this.cookieService.delete('nationalNumber','/');
      this.cookieService.delete('access_token','/');
      this.cookieService.delete('role','/');

    }
  }


}
